<template>
  <div class="road-list">
    <div class="road-list_content">
      <div class="road-list_content_close" @click="clickReturn">
        <img src="../../assets/img/pc/close.png" alt="" />
      </div>
      <div
        class="road-list_content_pic"
        v-for="(item, index) in roadList"
        :key="index"
        v-show="index === roadListIndex"
      >
        <img :src="item.mapPic" alt="" />
        <div
          :class="{
            'road-list_content_pic_marker': moudleMap,
            'road-list_content_pic_marker2': !moudleMap,
            'road-list_content_pic_marker--read': markerItem.read,
            'road-list_content_pic_marker--start': markerIndex === 0,
            'road-list_content_pic_marker--end':
              markerIndex == item.mapMarker.length - 1,
          }"
          v-for="(markerItem, markerIndex) in item.mapMarker"
          :key="markerIndex"
          :style="{ left: markerItem.abscissa, top: markerItem.ordinate }"
          @click="clickMarker(markerItem, index)"
        ></div>
        <transition name="fade">
          <div class="road-list_content_pic_tips" v-show="tipsShow">
            <p>点击</p>
            <img
              class="road-list_content_pic_tips_icon"
              src="../../assets/img/roadlist_marker.png"
              alt=""
            />
            <p>了解更多红色故事</p>
          </div>
        </transition>
      </div>

      <div
        class="road-list_content_text"
        v-for="(item, index) in roadList"
        :key="index + '123'"
        v-show="index === roadListIndex"
      >
        <div class="road-list_content_text_title">{{ item.name }}</div>
        <div
          class="road-list_content_text_value"
          v-html="
            item.description ? item.description.replace(/\n/g, '<br />') : ''
          "
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['roadList', 'roadListIndex', 'tipsShow', 'moudleMap'],
  data() {
    return {}
  },
  methods: {
    clickMarker(item, index) {
      // console.log(item.entityId)
      this.$emit('setPano', item.entityId, index)
    },
    clickReturn() {
      this.$emit('setPano', '')
    },
    // swiperChange() {
    //   this.$emit('swiperChange', this.$refs.topSwiper.$swiper.realIndex)
    //   // console.log(this.$refs.topSwiper.$swiper.realIndex)
    // },
  },
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
.road-list {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  .road-list_content {
    width: rem(1440);
    height: rem(840);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url('../../assets/img/pc/roadlist_content-bg.png') no-repeat
      center center/100% 100%;
    display: flex;
    align-items: center;
    padding-left: rem(30);
    box-sizing: border-box;
  }
  .road-list_content_pic_tips {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: rem(30);
    width: rem(320);
    height: rem(60);
    padding: 0 rem(40);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: rem(16);
    background: rgba(26, 26, 26, 0.4);
    border-radius: 5px;
    .road-list_content_pic_tips_icon {
      display: block;
      width: rem(30);
      margin-left: rem(8);
    }
  }
  .road-list_content_close {
    cursor: pointer;
    width: rem(30);
    height: rem(30);
    position: absolute;
    right: rem(30);
    top: rem(30);
    z-index: 9;
    img {
      display: block;
      width: 100%;
    }
  }
  .road-list_content_pic {
    width: rem(440);
    position: relative;
    margin-right: rem(100);
    img {
      display: block;
      width: 100%;
      border-radius: 10px;
    }
  }
  .road-list_content_pic_marker {
    cursor: pointer;
    width: rem(35);
    height: rem(48);
    background: url('../../assets/img/roadlist_marker.png') no-repeat center
      center/100% 100%;
    position: absolute;
    transform: translate(-50%, -60%);
    &.road-list_content_pic_marker--read {
      width: rem(40);
      height: rem(55);
    }
    &.road-list_content_pic_marker--start {
      background: url('../../assets/img/roadlist_marker-start.png') no-repeat
        center center/100% 100%;
    }
    &.road-list_content_pic_marker--end {
      background: url('../../assets/img/roadlist_marker-end.png') no-repeat
        center center/100% 100%;
    }
  }
  .road-list_content_pic_marker2 {
    cursor: pointer;
    width: rem(32);
    height: rem(35);
    background: url('../../assets/img/roadlist_marker2.png') no-repeat center
      center/100% 100%;
    position: absolute;
    transform: translate(-50%, -51%);
  }
  .road-list_content_text {
    width: rem(760);
  }
  .road-list_content_text_title {
    text-align: center;
    margin-bottom: rem(40);
    color: rgba(255, 229, 184, 1);
    font-size: rem(36);
  }
  .road-list_content_text_value {
    height: rem(300);
    font-size: rem(20);
    color: #fff;
    overflow-y: auto;
  }
}
</style>
